import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsCmiLabelStyles {
    wrapper?: InjectableCss;
    text?: TypographyPresentationProps;
    link?: LinkPresentationProps;
}

export const cmiLabelStyles: ProductDetailsCmiLabelStyles = {
    wrapper: {
        css: css`
            display: inline-flex;
            flex-direction: column;
            margin-bottom: 15px;
        `,
    },
    text: {
        weight: 600,
    },
};

const styles = cmiLabelStyles;

const ProductDetailsCmiLabel: React.FC<Props> = ({ product }) => {
    const cmiProductsCount = +(product.properties["cmiProductsCount"] ?? 0);
    const cmiProductsText = product.properties["cmiProductsText"] ?? "";

    if (cmiProductsCount < 1 || cmiProductsText === "") {
        return null;
    }

    const handleAccordionClick = (event: React.MouseEvent<Element, MouseEvent>) => {
        event.preventDefault();
        const cmiAccordion = document.getElementById("cmi-accordion-trigger");
        if (cmiAccordion) {
            cmiAccordion.scrollIntoView({ behavior: "smooth" });

            if (cmiAccordion.getAttribute("aria-expanded") !== "true") {
                cmiAccordion.click();
            }
        }
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.text}>{cmiProductsText} </Typography>
            <Link {...styles.link} onClick={handleAccordionClick}>
                {translate("View Customer Materials")}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsCmiLabel),
    definition: {
        displayName: "CMI Label",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
